import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { catchError, Observable, throwError, map } from 'rxjs';

import { CmsFooterService } from '@digital-platform/rs-cms/services';

@Injectable()
export class EmailValidationService {
  private httpClient = inject(HttpClient);

  constructor(@Inject(CmsFooterService) private _service: CmsFooterService) {}

  public validate(email: string): Observable<any> {
    const emailsValidateEndPoint = '/api/v1/emails/validate';

    return this.httpClient
      .post<any>(`${emailsValidateEndPoint}`, { emailAddress: email })
      .pipe(
        map((res) => res),
        catchError((error: HttpErrorResponse) => {
          const Obj = {
            invalid: true,
            errorMessage: 'Please enter a valid email address',
          };
          switch (error.status) {
            default:
              this._service.emailInputError$.next(Obj);
              break;
          }
          return throwError('Invalid Email Entered');
        })
      );
  }
}
